import React from 'react';
import { APP_NAME, APP_TAGLINE } from '../../constants/appConstants';
import SiteFooter from '../SiteFooter/SiteFooter';
import './AuthShell.css';

const PARTICLE_COUNT = 28;
const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo192.png?v=8`;

const PARTICLES = Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
    id: i,
    left: `${(i * 17 + 7) % 100}%`,
    top: `${(i * 23 + 11) % 100}%`,
    delay: `${(i % 8) * 0.6}s`,
    duration: `${3 + (i % 5)}s`,
    size: 2 + (i % 3),
}));

/**
 * 登录/注册共用布局
 */
class AuthShell extends React.Component {
    render() {
        const { title, subtitle, children } = this.props;

        return (
            <div className="auth-shell">
                <div className="auth-bg">
                    <div className="auth-bg__gradient" aria-hidden="true" />
                    <div className="auth-bg__grid" aria-hidden="true" />
                    <div className="auth-bg__orb auth-bg__orb--cyan" aria-hidden="true" />
                    <div className="auth-bg__orb auth-bg__orb--violet" aria-hidden="true" />
                    <div className="auth-bg__lines" aria-hidden="true">
                        <span /><span /><span />
                    </div>
                    {PARTICLES.map((p) => (
                        <span
                            key={p.id}
                            className="auth-particle"
                            style={{
                                left: p.left,
                                top: p.top,
                                width: p.size,
                                height: p.size,
                                animationDelay: p.delay,
                                animationDuration: p.duration,
                            }}
                            aria-hidden="true"
                        />
                    ))}
                </div>

                <div className="auth-layout">
                    <aside className="auth-showcase">
                        <div className="auth-showcase__inner">
                            <div className="auth-showcase__logo">
                                <img
                                    src={LOGO_SRC}
                                    alt=""
                                    className="auth-showcase__logo-img"
                                    width={88}
                                    height={88}
                                />
                            </div>
                            <h1 className="auth-showcase__title">{APP_NAME}</h1>
                            <p className="auth-showcase__tagline">{APP_TAGLINE}</p>
                            <p className="auth-showcase__desc">
                                个人非经营性网站
                                <br />
                                学习笔记与资料整理
                            </p>
                        </div>
                    </aside>

                    <main className="auth-main">
                        <div className="auth-card">
                            <div className="auth-card__shine" aria-hidden="true" />
                            <div className="auth-card__header">
                                <h2 className="auth-card__title">{title}</h2>
                                {subtitle && <p className="auth-card__desc">{subtitle}</p>}
                            </div>
                            <div className="auth-card__body">{children}</div>
                        </div>
                    </main>
                </div>
                <SiteFooter variant="dark" />
            </div>
        );
    }
}

export default AuthShell;
